export class DefaultService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns Note Ok
     * @throws ApiError
     */
    getNotes() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notes',
        });
    }
    /**
     * @param requestBody
     * @returns Note Ok
     * @throws ApiError
     */
    createNote(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns boolean Ok
     * @throws ApiError
     */
    updateNote(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/notes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * A very very very basic search. Doesn't tokenize. Case insensitive.
     * @param query the query to search with
     * @returns Note Ok
     * @throws ApiError
     */
    search(query) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notes/search',
            query: {
                'query': query,
            },
        });
    }
    /**
     * @param id
     * @returns Note Ok
     * @throws ApiError
     */
    findById(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notes/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns boolean Ok
     * @throws ApiError
     */
    deleteNote(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/notes/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns PingResponse Ok
     * @throws ApiError
     */
    getMessage() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ping',
        });
    }
}
